module.exports = __webpack_public_path__ + "media/images/icons/linked-in-296f87c6aec2ee319e22d831729c2ad5.svg";